import React from 'react';
import { useTheme } from '@emotion/react';

export const ProgressBar = ({ width }: any) => {
  const theme: any = useTheme();
  return (
    <div
      style={{
        width: `${width}%`,
        height: 8,
        backgroundColor: theme.custom.colors.group1.base
      }}
    />
  );
};
